<template>
  <div class="section-adsperformance">
    <Section>
      <div class="section-header" slot="header">
        <h1 class="title">Ads Performance</h1>
      </div>
      <div class="section-body">
        <div class="row">
          <AdsCard v-if="adsData && !isError && !isLoading" :adsCardData="mappedAdsData" />
          <EmptyMessage v-if="!isLoading && isEmpty && !isError">
            ไม่พบข้อมูลในช่วงเวลาดังกล่าว
          </EmptyMessage>
          <EmptyMessage v-if="!isLoading && isError">
            <h3>พบข้อผิดพลาดระหว่างโหลดข้อมูล</h3>
            <p>
              โปรดรอซักครู่เพื่อโหลดข้อมูลใหม่ หรือติดต่อ
              <a
                :href="`mailto:support@byteark.com`"
                target="_top"
              >support@byteark.com</a>
            </p>
            <span slot="code" class="code">error code : {{error.status || 'not found' }} </span>
          </EmptyMessage>
          <div v-if="isLoading" class="d-flex justify-content-center">
            <div class="spinner-border" role="status" />
          </div>
        </div>
      </div>
    </Section>
  </div>
</template>

<script>
import _ from 'lodash';
import AdsCard from '@/performance/AdsCard.vue';
import Section from '@/components/Section.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';

export default {
  props: ['adsData', 'isLoading', 'isError', 'error'],
  components: {
    Section,
    EmptyMessage,
    AdsCard,
  },
  computed: {
    isEmpty() {
      return _.isEmpty(this.adsData);
    },
    mappedAdsData() {
      return this.mapAdsData();
    },
  },
  data() {
    return {
    };
  },
  created() {},
  methods: {
    mapAdsData() {
      const data = [
        {
          key: 'Ads Clicked',
          value: this.adsData.ad_click,
        },
        {
          key: 'Ads Requested',
          value: this.adsData.ad_request,
        },
        {
          key: 'Ads Completed',
          value: this.adsData.ad_complete,
        },
        {
          key: 'Ads Impression',
          value: this.adsData.ad_impression,
        },
        {
          key: 'Ads Error',
          value: this.adsData.ad_error,
        },
        {
          key: 'Ads Skipped',
          value: this.adsData.ad_skipped,
        },
      ];

      return _.cloneDeep(data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';


a {
  color: $primary;
}

.progress-container {
  margin: $spacer * 3 $spacer;
}

.slice {
  position: absolute;
  z-index: 1000;
  height: $spacer * 5;
  width: $spacer / 2;
  background: $gray-600;
  border-radius: 2px;
}

.progress {
  height: $spacer * 4;
}

.section-adsperformance {
  .section {
    min-height: 400px;
    height: 100%;
  }
}

.ads-block {
  background: #feb019 !important;
}

.total-play {
  background: #008ffb !important;
}

@media (min-width: 320px) and (max-width: 767.98px) {
  .section-adsperformance {
    .section {
      min-height: 300px !important;
      height: 100%;
    }
  }
}

@media (min-width: 768px) and (max-width: 1199.98px) {
}
</style>
